
import React, { useEffect } from 'react';
import OTOHero from '@/components/oto/OTOHero';
import CongratulationsProblemSection from '@/components/oto/CongratulationsProblemSection';
import TheWallSection from '@/components/oto/TheWallSection';
import SolutionIntroductionSection from '@/components/oto/SolutionIntroductionSection';
import TimeEffortComparisonSection from '@/components/oto/TimeEffortComparisonSection';
import ProfessionalPositioningSection from '@/components/oto/ProfessionalPositioningSection';
import ObjectionHandlingSection from '@/components/oto/ObjectionHandlingSection';
import DecisionReinforcementSection from '@/components/oto/DecisionReinforcementSection';
import FinalOfferCTASection from '@/components/oto/FinalOfferCTASection';

const OTO = () => {
  useEffect(() => {
    // Show the static container when this component mounts
    const container = document.getElementById('thrivecart-upsell-container');
    if (container) {
      container.style.display = 'block';

      // Log verification
      console.log('ThriveCart container mounted');
      console.log('ThriveCart global object:', window.ThrivecartUpsells);
    }

    // Hide the container when component unmounts
    return () => {
      const container = document.getElementById('thrivecart-upsell-container');
      if (container) {
        container.style.display = 'none';
      }
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <main className="flex-grow">
        <OTOHero />
        <CongratulationsProblemSection />
        <TheWallSection />
        <SolutionIntroductionSection />
        <TimeEffortComparisonSection />
        <ProfessionalPositioningSection />
        <ObjectionHandlingSection />
        <DecisionReinforcementSection />
        <FinalOfferCTASection />
      </main>
    </div>
  );
};

export default OTO;
